/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const TransferListStyle = makeStyles((theme: Theme) => ({
  root: {
    margin: 'auto'
  },
  mrgnLeftM14P: {
    marginLeft: `-${theme.spacing(1.75)}`
  },
  mrgnLft20P: {
    marginLeft: `${theme.spacing(2.75)}%`,
    position: 'static',
    marginTop: `-${theme.spacing(0.375)}`,
    color: '#3F4756BD',
    padding: 0,
    fontSize: `${theme.spacing(1.5)}px`,
    fontFamily: 'Roboto,Helvetica,Arial,sans-serif',
    fontWeight: 'normal',
    lineHeight: theme.spacing(0.125)
  },
  leftPanel: {
    marginLeft: `-${theme.spacing(0.375)}`,
    overflowX: 'hidden',
    padding: `${theme.spacing(1)}px 0 ${theme.spacing(1)}px 0`,
    marginRight: `${theme.spacing(1.75)}px !important`,
  },
  title: {
    fontSize: `${theme.spacing(2.5)}px`,
    lineHeight: `${theme.spacing(2.875)}px`,
    color: theme.palette.secondary.dark
  },
  paper: {
    width: theme.spacing(52.625),
    height: theme.spacing(40),
    overflowY: 'auto',
    marginTop: `${theme.spacing(1.25)}`,
    cursor: 'pointer',
    border: `${theme.spacing(0.125)} solid #dce2e9`,
    boxShadow: 'none!important',
    overflowX: 'hidden',
    padding: `0 ${theme.spacing(0.625)}`
  },
  button: {
    margin: theme.spacing(0.5, 0),
    padding: '0px',
    minWidth: theme.spacing(2.5)
  },
  ftLeft: {
    float: 'left'
  },
  ftRight: {
    float: 'right'
  },
  rightPanel: {
  },
  lstCheckBox: {
    paddingTop: '0px',
    textTransform: 'capitalize'
  },
  entityLabel: {
    font: 'normal normal 14px/20px',
    color: '#3F4756'
  },
  addClearText: {
    fontSize: `${theme.spacing(1.75)}px`,
    color: '#047ABC',
    float: 'right',
    cursor: 'pointer'
  },
  entityListSearch: {
    '& div.MuiInput-underline:before': {
      borderBottom: `${theme.spacing(0.1875)}px solid #a1a1a1 !important`
    },
    width: '100%',
    margin: theme.spacing(1.25, 0)
  },
  filteredEntityList: {
    display: 'none'
  },
  highlight: {
    background: '#FFF9C4',
    color: '#3E3E3E'
  },
  mrT30P: {
    marginTop: `${theme.spacing(3.75)}px`,

    '& .MuiGrid-container': {
      maxWidth: '80% !important',
      flexBasis: '80% !important',
      margin: '0 0 0 27px'
    }
  },
  labelDisabled: {
    color: '#B8B8B8 !important',
    pointerEvent: 'none',
    cursor: 'auto'
  },
  width400: {
    maxWidth: `${theme.spacing(47.5)}px !important`
  }
}));